import { useState } from "react";
import PackMappingViewer from "./PackMappingViewer";
import MappingProps from "./mappingProps";

type BatchLoadingPackCalculatorMappingsProps = {
  mappings: MappingProps[];
};


const BatchLoadingPackCalculatorMappings = ({ mappings }: BatchLoadingPackCalculatorMappingsProps) => {
    const batchSize = 5;
    const [mappingsLoaded, setMappingsLoaded] = useState<Set<String>>(new Set());

    return <>
        {
            mappings.slice(0, mappingsLoaded.size + batchSize).map((mapping: MappingProps, idx: number) => (
                <PackMappingViewer key={idx} mapping={mapping} mappingsLoaded={mappingsLoaded} setMappingsLoaded={setMappingsLoaded} />
            ))
        }
    </>
};

export default BatchLoadingPackCalculatorMappings;